import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { formatRFC3339 } from 'date-fns/esm';
import { TransactionDebitGroupItem } from '@zerops/models/transaction-debit';
import { ZefWebsocketService } from '@zerops/zef/websocket';

@Injectable({ providedIn: 'root' })
export class TransactionDebitBaseApi {
  constructor(
    private _http: HttpClient,
    private _wsService: ZefWebsocketService
  ) { }

  groupSearch$(request: {
    search: Array<{ name: string; operator: string; value: string; }>;
    receiverId?: string;
    subscriptionName: string;
    groupBy: string;
    timeGroupBy: string;
    timeZone: string;
    limit?: number;
    from?: string | Date;
    till?: string | Date;
  }) {
    return this._http.post<{ items: TransactionDebitGroupItem[]; }>(
      '/api/transaction-debit/group-by-search',
      {
        ...request,
        receiverId: request.receiverId || this._wsService.getReceiverId(),
        from: request.from && !request.limit ? (typeof request.from === 'string' ? request.from : formatRFC3339(request.from)) : undefined,
        till: request.till && !request.limit ? (typeof request.till === 'string' ? request.till : formatRFC3339(request.till)) : undefined
      }
    );
  }

  periodCost$(clientId: string) {
    return this._http.post<any>(
      '/api/transaction-debit/cost-search',
      {
        search: [
          {
            name: 'clientId',
            operator: 'eq',
            value: clientId
          }
        ]
      }
    );
  }

}
